import React, { useMemo, useEffect } from "react";
import { WidgetProps } from '@rjsf/core';
import { Message, Dropdown, DropdownItemProps } from "semantic-ui-react";
import { useSchemaTranslation } from "../../../useSchemaTranslation";

export const DropdownWidget: React.FC<WidgetProps> = (props) => {
    const { t } = useSchemaTranslation();
    const { value, options, onChange } = props;

    const validateOptions = (opts: any[]): opts is DropdownItemProps[] => {
        if (!opts) {
            return false;
        }

        if (!Array.isArray(opts)) {
            return false;
        }

        return opts.every((opt) => {
            return opt.value !== undefined && opt.text !== undefined;
        });
    }

    const optionsAreValid = validateOptions(options.options as any);

    useEffect(() => {
        if (value === undefined) {
            onChange((options.options as any)[0].value);
        }
    }, [value]);

    if (!optionsAreValid) {
        return (
            <Message negative>
                <Message.Header>Määritysvirhe</Message.Header>
                <Message.Content>Pudotusvalikon määrityksessä on virhe. Ota yhteys ylläpitäjään.</Message.Content>
            </Message>
        );
    }

    const translatedOptions = (options.options as any[]).map((opt) => ({ ...opt, text: t(opt.text) }))

    return (
        <Dropdown
            selection
            selectOnBlur={true}
            options={translatedOptions}
            value={value}
            onChange={(_, { value }) => onChange(value)}
        />
    );
};
